
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppInvoiceReceiveDialog extends Serenity.EntityDialog<ListAppInvoiceReceiveRow, any> {
        protected getFormKey() { return ListAppInvoiceReceiveForm.formKey; }
        protected getIdProperty() { return ListAppInvoiceReceiveRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppInvoiceReceiveRow.localTextPrefix; }
        protected getNameProperty() { return ListAppInvoiceReceiveRow.nameProperty; }
        protected getService() { return ListAppInvoiceReceiveService.baseUrl; }
        protected getDeletePermission() { return ListAppInvoiceReceiveRow.deletePermission; }
        protected getInsertPermission() { return ListAppInvoiceReceiveRow.insertPermission; }
        protected getUpdatePermission() { return ListAppInvoiceReceiveRow.updatePermission; }

        protected form = new ListAppInvoiceReceiveForm(this.idPrefix);

    }
}